export const invertedMessages = {
  'Got it': 'CERTS_SAVI_GOT_IT',
};
